/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Sv } from './Sv';

const { GlobalVar } = Utils;

class Course extends Sv {
    constructor() {
        super();
        this.baseUrl += '/course';
    }

    data({ courseName, certCatId, schoolOrgId, currentPage, pageSize } = {}) {
        return super.get('/data', {
            courseName,
            certCatId,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { courseImage } = json.data.data;
            if (!courseImage) {
                json.data.data.courseImage = [];
            } else {
                json.data.data.courseImage = courseImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            const { courseVoiceFile } = json.data.data;
            if (!courseVoiceFile) {
                json.data.data.courseVoiceFile = [];
            } else {
                json.data.data.courseVoiceFile = courseVoiceFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        certCatId,
        certId,
        courseName,
        courseImage,
        courseType,
        courseFile,
        courseVoiceFile,
        orderNum,
        courseDesc,
        schoolOrgId,
    } = {}) {
        const courseImageStr = courseImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const courseVoiceFileStr = courseVoiceFile
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post(
            '/save',
            {
                id,
                certCatId,
                certId,
                courseName,
                courseImage: courseImageStr,
                courseType,
                courseFile,
                courseVoiceFile: courseVoiceFileStr,
                orderNum,
                courseDesc,
                schoolOrgId,
            },
            { timeout: 0 },
        );
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    changeCourseStatus({ id, courseStatus } = {}) {
        return super.post('/changeCourseStatus', {
            id,
            courseStatus,
        });
    }
}

export default new Course();
export { Course };
